import { Dialog, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DialogHeader from "./../dialog/DialogHeader";
import DialogBody from "./../dialog/DialogBody";
import { appIcons } from "../../assets";
import { useSnackbar } from "../../lib/context/snackbarContext";
import AddressCard from "../cards/AddressCard";
import { setUserAddress } from "../../lib/redux/slices/userAddressSlice";
import GlobalButton from "../button";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "600px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));

const UserAllAddressDialog = forwardRef(({ openAddAddressDialog }, ref) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const selectedAddress = useSelector(
    (state) => state.userAddressReducer.userAddress
  );
  const userAllAddress = useSelector((state) => state.addressReducer.data);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      setOpen(true);
    },
    closeDialog() {
      handleClose();
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeAddress = (event) => {
    const value = event.target.value;
    const selected = userAllAddress.find((x) => x._id === value);
    dispatch(setUserAddress(selected));
    localStorage.setItem("user_address", JSON.stringify(selected));
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      disableScrollLock
    >
      <DialogHeader
        title={t("allAddress")}
        secondaryHeading={t("selectAddress")}
        icon={<img src={appIcons.purpleFeesIcon} width={30} />}
        onClose={handleClose}
      />
      <DialogBody>
        <Stack gap={2}>
          {userAllAddress?.length === 0 && (
            <Typography
              variant="h6"
              fontWeight={600}
              textAlign={"center"}
              my={2}
            >
              {t("noAddressFound")}!
            </Typography>
          )}

          {userAllAddress.map((val, index) => {
            return (
              <AddressCard
                cardData={val}
                selectedValue={selectedAddress?._id}
                handleChange={handleChangeAddress}
              />
            );
          })}
        </Stack>
        <GlobalButton
          variant={"contained"}
          btnText={"addAddress"}
          handleClickBtn={() => {
            setOpen(false);
            openAddAddressDialog();
            // navigate("/dashboard/address-book");
          }}
          styleProps={{
            mt: 2,
            width: "100%",
          }}
        />
      </DialogBody>
    </BootstrapDialog>
  );
});

export default UserAllAddressDialog;
